import { createContext } from 'react'

const settingsContext = createContext()

export default settingsContext
